"use client";

import EngineDateTable from "@/components/vrat/EngineDateTable";
import type { CalendarPurnimaItem } from "@/lib/api/calendar";

export interface PurnimaYearData {
  year: number;
  purnimas: CalendarPurnimaItem[];
}

export default function PurnimaDates({ years }: { years: PurnimaYearData[] }) {
  return (
    <EngineDateTable
      years={years.map(({ year, purnimas }) => ({ year, entries: purnimas }))}
      tabLabel="Purnima"
      itemHeader="Purnima"
      detailHeader="Hindu month"
      emptyMessage="Purnima dates are computed live from the Vedic engine. The schedule could not be loaded right now — please refresh in a moment to see every full-moon date with its lunar month."
      footer="All Purnima dates are computed from real planetary positions using the Swiss Ephemeris engine with Lahiri Ayanamsa — the tithi boundary, not a fixed calendar."
    />
  );
}
